import { Directive, TemplateRef } from '@angular/core'

@Directive({
	selector: '[uiCommonAccordionTitle]',
})
export class AccordionTitleDirective {
	constructor(public templateRef: TemplateRef<unknown>) {}
}
